export default __webpack_public_path__ + "static/media/BottomWave.f375e3fa.svg";